module.exports = __webpack_public_path__ + "media/images/front/banner_jobmesse_dr_side-28d8b56d5ee302536b27f3d3c8201e6c.jpg";